/** Текст ошибки упавшей задачи героини. 402 бывает и от OpenRouter (нет кредитов), и от Google напрямую
 * (кончилась предоплата) — текст Google уже называет причину и где пополнить, подменять его нельзя. */
export const NO_CREDITS =
  "Нет кредитов OpenRouter: пополнить баланс (около $7 на 05.10) или ждать сброса лимита $30 1-го числа";

const GOOGLE_PREPAY = "Кончилась предоплата Google";

export function runErrorText(httpStatus: number | null, error: string | null): string {
  if (httpStatus === 402 && !(error ?? "").startsWith(GOOGLE_PREPAY)) return NO_CREDITS;
  return error ?? "ошибка";
}
